<template>
  <section class="Introduction-container">
    <div class="Introduction-content max-width">
      <div class="left">
        <div class="title-container">
          <div class="main-title">WE ARE</div>
          <div class="sub-title">CREATIVE</div>
        </div>
        <div class="left-content">
          <h5 class="content-title">集团简介</h5>
          <p class="Introduction-text">
            厦门久凌科技集团有限公司（简称“久凌科技”）成立于2019年，地处海上花园
            厦门的标志性建筑——华润万象城办公楼A座。作为厦门国资委投资的高新技术企业，
            集团专注于大型政企、军工系统集成整体解决、软件开发、机房建设、服务器等保、
            数据中心建设，信息化整体解决等板块。集团拥有一支丰富信息化项目经验的专业
            团队，能够以最短的时间开发出高性能的产品，使用最前沿技术分布式、微服务、
            人工智能算法等，为我们的客户提供最佳解决方案。旗下拥有厦门久凌创新科技有限
            公司、厦门久凌未蓝网络有限公司。
          </p>

          <p class="Introduction-text">
            厦门久凌创新科技有限公司主营方向是军工和政府系统集成类项目解决方案和信息化
            软件开发项目。厦门久凌未蓝网络有限公司主营方向是大型企业系统信息化集成类项
            目解决方案和信息化软件开发项目。
          </p>
        </div>
      </div>
      <div class="right">
        <!-- <img class="Introduction-img" v-lazy="'http://jlimage.90cx.cn/'+'矩形 20@2x.png'" />
        <img class="Introduction-img" v-lazy="'http://jlimage.90cx.cn/'+'矩形 3@2x.png'" /> -->
        <img
          class="Introduction-img"
          src="../../../assets/home/矩形 20@2x.png"
        />
        <img
          class="Introduction-img"
          src="../../../assets/home/矩形 3@2x.png"
        />
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'Introduction',
};
</script>

<style lang="scss" scoped>
@import url('~@/assets/css/common.scss');
.Introduction-container {
  user-select: none;
  padding: 196px 0;
  background-color: #fff;
  .Introduction-content {
    max-width: 1366px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: auto;
    .left {
      flex-grow: 375;
      font-size: 26px;
      position: relative;
      .left-content {
        width: 500px;
      }
      &:before {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 60px;
        height: 3px;
        background-color: #30659b;
      }
      .title-container {
        font-weight: bold;
      }
      .content-title {
        color: #333;
        font-size: 18px;
        font-weight: bold;
        line-height: 32px;
        margin: 0;
      }
      .Introduction-text {
        font-size: 14px;
        line-height: 220%;
        margin-bottom: 40px;
      }
    }
    .right {
      flex-grow: 560;
      .Introduction-img {
        float: right;
        width: 80%;
        display: block;
        &:nth-child(2n) {
          margin-top: 20px;
        }
      }
    }
  }
}
</style>
